import g, { css as f } from "styled-components";
import { breakpoints as t } from "./atoms-v2125.js";
import { Base as l } from "./atoms-v2777.js";
const a = ({
  colorTheme: r = "light",
  isDisabled: n,
  isFocused: i,
  isHovered: s = !1,
  theme: o,
  variant: d
}) => d === "expressive" ? "transparent" : d === "productive" ? n && s ? o == null ? void 0 : o.get(`tokens.surface.${r}.background`) : !n && s ? o == null ? void 0 : o.get(`ui.field.${r}.bkgHover`) : o == null ? void 0 : o.get(`ui.field.${r}.background.default`) : i ? o == null ? void 0 : o.get(`tokens.surface.${r}.background`) : "transparent", u = ({
  colorTheme: r = "light",
  errored: n = !1,
  focused: i = !1,
  hovered: s,
  theme: o,
  variant: d
}) => s && d === "expressive" ? o == null ? void 0 : o.get(`ui.field.${r}.borderHover`) : n ? o == null ? void 0 : o.get(`tokens.border.${r}.error`) : i ? o == null ? void 0 : o.get(`ui.field.${r}.borderHover`) : o == null ? void 0 : o.get(`ui.field.${r}.border`), k = g.div`
  ${l}

  background-color: ${({ $colorTheme: r = "light", $isFocused: n, $variant: i, theme: s }) => a({ colorTheme: r, isFocused: n, theme: s, variant: i })};
  border-radius: ${({ $isGroupedInput: r, $variant: n, theme: i }) => n === "expressive" || r ? 0 : i == null ? void 0 : i.get("tokens.radius.fieldRadiusSm")}px;
  box-shadow: ${({ $variant: r }) => r === "expressive" ? "inset 0 -1px 0" : "0 0 0 1px"}
    ${({ $colorTheme: r = "light", $isErrored: n, $isFocused: i, $variant: s, theme: o }) => u({
  colorTheme: r,
  errored: n,
  focused: i,
  theme: o,
  variant: s
})};
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
  transition:
    background-color ${({ theme: r }) => r == null ? void 0 : r.get("tokens.motion").toString("duration.fast")}
      ${({ theme: r }) => r == null ? void 0 : r.get("tokens.motion").toString("easing.standard")},
    box-shadow ${({ theme: r }) => r == null ? void 0 : r.get("tokens.motion").toString("duration.fast")}
      ${({ theme: r }) => r == null ? void 0 : r.get("tokens.motion").toString("easing.standard")},
    color ${({ theme: r }) => r == null ? void 0 : r.get("tokens.motion").toString("duration.fast")}
      ${({ theme: r }) => r == null ? void 0 : r.get("tokens.motion").toString("easing.standard")};
  z-index: ${({ $isErrored: r, $isFocused: n }) => n || r ? 1 : 0};

  &:hover {
    background-color: ${({ $colorTheme: r = "light", $isDisabled: n, $isFocused: i, $variant: s, theme: o }) => a({
  colorTheme: r,
  isDisabled: n,
  isFocused: i,
  isHovered: !0,
  theme: o,
  variant: s
})};

    ${({ $colorTheme: r = "light", $isErrored: n, $isFocused: i, $variant: s, theme: o }) => s === "expressive" && f`
        box-shadow: inset 0 -1px 0 ${u({ colorTheme: r, errored: n, focused: i, hovered: !0, theme: o, variant: s })};
      `};
  }

  @media ${t.medium} {
    border-radius: ${({ $isGroupedInput: r, $variant: n, theme: i }) => n === "expressive" || r ? 0 : i == null ? void 0 : i.get("tokens.radius.fieldRadiusMed")}px;
  }
`;
export {
  k as InputOutline
};
